import { Link } from 'react-router-dom'
import { SiteContentLayout } from '../components/SiteContentLayout'
import { ABOUT_PAGE } from '../constants/about-page'

export function AboutPage() {
  return (
    <SiteContentLayout
      eyebrow={ABOUT_PAGE.eyebrow}
      title={ABOUT_PAGE.title}
      lead={ABOUT_PAGE.intro[0]}
    >
      <div className="content-page__prose">
        {ABOUT_PAGE.intro.slice(1).map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.whoWeAre.title}</h2>
          <p>{ABOUT_PAGE.whoWeAre.body}</p>
          <p>{ABOUT_PAGE.whoWeAre.extra}</p>
        </section>

        <div className="content-page__split">
          <section className="content-page__card">
            <h2>{ABOUT_PAGE.vision.title}</h2>
            <p>{ABOUT_PAGE.vision.body}</p>
          </section>
          <section className="content-page__card">
            <h2>{ABOUT_PAGE.mission.title}</h2>
            <ul className="content-page__list">
              {ABOUT_PAGE.mission.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        </div>

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.offersTitle}</h2>
          <div className="content-page__offer-grid">
            {ABOUT_PAGE.offers.map((group) => (
              <article key={group.title} className="content-page__card">
                <h3>{group.title}</h3>
                <ul className="content-page__list">
                  {group.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.whyTitle}</h2>
          <ul className="content-page__chips">
            {ABOUT_PAGE.whyItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.industriesTitle}</h2>
          <ul className="content-page__chips">
            {ABOUT_PAGE.industries.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.valuesTitle}</h2>
          <ul className="content-page__chips content-page__chips--values">
            {ABOUT_PAGE.values.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <div className="content-page__split">
          <section className="content-page__card">
            <h2>{ABOUT_PAGE.commitment.title}</h2>
            <p>{ABOUT_PAGE.commitment.body}</p>
          </section>
          <section className="content-page__card">
            <h2>{ABOUT_PAGE.sustainability.title}</h2>
            <p>{ABOUT_PAGE.sustainability.body}</p>
          </section>
        </div>

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.promiseTitle}</h2>
          <ul className="content-page__list">
            {ABOUT_PAGE.promiseItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.companyTitle}</h2>
          <dl className="content-page__facts">
            {ABOUT_PAGE.companyFacts.map((fact) => (
              <div key={fact.label} className="content-page__fact">
                <dt>{fact.label}</dt>
                <dd>
                  {'href' in fact && fact.href ? (
                    <a href={fact.href}>{fact.value}</a>
                  ) : (
                    fact.value
                  )}
                </dd>
              </div>
            ))}
          </dl>
        </section>

        <section className="content-page__section">
          <h2>{ABOUT_PAGE.closingTitle}</h2>
          <p>{ABOUT_PAGE.closing}</p>
          <Link className="content-page__cta" to={ABOUT_PAGE.ctaTo}>
            {ABOUT_PAGE.ctaLabel}
          </Link>
        </section>
      </div>
    </SiteContentLayout>
  )
}
